import { Button } from '@dropbox/dig-components/buttons';
import { UIIcon } from '@dropbox/dig-icons';
import { AttachLine } from '@dropbox/dig-icons/dist/mjs/assets';
import { useAtom } from 'jotai';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isAttachmentsDrawerOpen } from 'signer-app/parts/attachments-drawer/attachments-drawer';

export function AttachmentsButton() {
  const [, setIsOpen] = useAtom(isAttachmentsDrawerOpen);
  return (
    <Button
      variant="outline"
      onClick={() => setIsOpen(true)}
      withIconStart={<UIIcon src={AttachLine} />}
    >
      <FormattedMessage
        id="signer.attachment.toolbar.button"
        description="Add attachments button label in toolbar when no drawer or form view is used"
        defaultMessage="Add attachments"
      />
    </Button>
  );
}
